<script setup lang="ts">
// Broadsheet footer: one quiet line of provenance + the contact links. The copy is runtime-editable
// via ContentText; the dynamic year binding stays coded.
import { computed } from 'vue'
import { useConventionStore } from '@/stores/convention'
import ContentText from '@/components/ContentText.vue'
const conv = computed(() => useConventionStore().convention)
</script>

<template>
  <footer class="bs-footer">
    <span>
      &copy; {{ conv?.year || 2027 }}
      <ContentText name="footer-copyright">
        Winter War &middot; Independently run since 1974 &middot; Champaign&ndash;Urbana, Illinois
      </ContentText>
    </span>
    <span>
      <ContentText name="footer-links">
        <a href="mailto:info@winterwar.org">Mailing list</a>
        <a href="https://www.facebook.com/groups/winterwar" target="_blank" rel="noopener noreferrer">Facebook group</a>
        <a href="mailto:registration@winterwar.org">Email the registrar</a>
      </ContentText>
    </span>
  </footer>
</template>
